import React, { useCallback } from 'react';
import chatService from '../services/chatService';
import MessageInput from './MessageInput';
import MessageList from './MessageList';

const Chat = ({ username, messages, connectedUsers, onDisconnect, activeChat, onSelectUser, onClearChat, privateMessages, unreadDMs }) => {
  const handleSendMessage = useCallback(async (message) => {
    if (activeChat) await chatService.sendPrivateMessage(activeChat, message);
    else await chatService.sendMessage(username, message);
  }, [username, activeChat]);
  const displayMessages = activeChat ? privateMessages[activeChat] || [] : messages;

  return (
    <section className="chat-container" aria-label="Messages">
      <header className="chat-header">
        <div className="user-info">
          <span className="user-avatar" aria-hidden="true">{activeChat ? activeChat.slice(0, 2).toUpperCase() : '#'}</span>
          <div className="chat-title"><span className="username-display">{activeChat || 'General chat'}</span><small>{activeChat ? 'Direct conversation' : `Signed in as ${username}`}</small></div>
        </div>
        <div className="chat-controls">
          <button type="button" className="btn-clear" onClick={onClearChat} title="Clear messages from this view">Clear view</button>
          <button type="button" className="btn-danger" onClick={onDisconnect}>Sign out</button>
        </div>
      </header>
      <div className="chat-content">
        <div className="chat-main">
          <MessageList messages={displayMessages} currentUsername={username} activeChat={activeChat} />
          <MessageInput onSendMessage={handleSendMessage} placeholder={activeChat ? `Message ${activeChat}…` : 'Type a message…'} />
        </div>
        <aside className="users-sidebar" aria-label="Conversations">
          <button type="button" className={`sidebar-general ${activeChat === null ? 'active' : ''}`} aria-pressed={activeChat === null} onClick={() => onSelectUser(null)}>
            <span className="room-symbol" aria-hidden="true">#</span><span>General chat</span>
          </button>
          <h3>Online now · {connectedUsers.length}</h3>
          <ul className="users-list">
            {connectedUsers.map((user) => {
              const isCurrentUser = user === username;
              const unread = unreadDMs[user] || 0;
              return (
                <li key={user}>
                  <button type="button" className={`user-button ${activeChat === user ? 'active' : ''}`} disabled={isCurrentUser}
                    aria-label={isCurrentUser ? `${user}, you` : `Chat with ${user}${unread ? `, ${unread} unread` : ''}`}
                    aria-pressed={activeChat === user} onClick={() => onSelectUser(user)}>
                    <span className="user-avatar" aria-hidden="true">{user.slice(0, 2).toUpperCase()}</span>
                    <span className="user-name-text">{user}{isCurrentUser && ' (you)'}</span>
                    {unread > 0 && <span className="unread-badge" aria-hidden="true">{unread}</span>}
                    <span className="online-dot" aria-hidden="true" />
                  </button>
                </li>
              );
            })}
          </ul>
        </aside>
      </div>
    </section>
  );
};

export default Chat;
